export default __webpack_public_path__ + "static/media/great.8a90bddb.svg";